import primaryButton from '../../../../primary-button';

const light = (params) => primaryButton.solidIcon.background.disabled.light(params);

export default light;
